const TimeZone = Object.freeze({
  GMT: 'GMT',
  AFRICA_ABIDJAN: 'AFRICA_ABIDJAN',
  AFRICA_ACCRA: 'AFRICA_ACCRA',
  AFRICA_ADDISABABA: 'AFRICA_ADDISABABA',
  AFRICA_ALGIERS: 'AFRICA_ALGIERS',
  AFRICA_ASMERA: 'AFRICA_ASMERA',
  AFRICA_BAMAKO: 'AFRICA_BAMAKO',
  AFRICA_BANGUI: 'AFRICA_BANGUI',
  AFRICA_BANJUL: 'AFRICA_BANJUL',
  AFRICA_BISSAU: 'AFRICA_BISSAU',
  AFRICA_BLANTYRE: 'AFRICA_BLANTYRE',
  AFRICA_BRAZZAVILLE: 'AFRICA_BRAZZAVILLE',
  AFRICA_BUJUMBURA: 'AFRICA_BUJUMBURA',
  AFRICA_CAIRO: 'AFRICA_CAIRO',
  AFRICA_CASABLANCA: 'AFRICA_CASABLANCA',
  AFRICA_CEUTA: 'AFRICA_CEUTA',
  AFRICA_CONAKRY: 'AFRICA_CONAKRY',
  AFRICA_DAKAR: 'AFRICA_DAKAR',
  AFRICA_DARESSALAAM: 'AFRICA_DARESSALAAM',
  AFRICA_DJIBOUTI: 'AFRICA_DJIBOUTI',
  AFRICA_DOUALA: 'AFRICA_DOUALA',
  AFRICA_ELAAIUN: 'AFRICA_ELAAIUN',
  AFRICA_FREETOWN: 'AFRICA_FREETOWN',
  AFRICA_GABORONE: 'AFRICA_GABORONE',
  AFRICA_HARARE: 'AFRICA_HARARE',
  AFRICA_JOHANNESBURG: 'AFRICA_JOHANNESBURG',
  AFRICA_KAMPALA: 'AFRICA_KAMPALA',
  AFRICA_KHARTOUM: 'AFRICA_KHARTOUM',
  AFRICA_KIGALI: 'AFRICA_KIGALI',
  AFRICA_KINSHASA: 'AFRICA_KINSHASA',
  AFRICA_LAGOS: 'AFRICA_LAGOS',
  AFRICA_LIBREVILLE: 'AFRICA_LIBREVILLE',
  AFRICA_LOME: 'AFRICA_LOME',
  AFRICA_LUANDA: 'AFRICA_LUANDA',
  AFRICA_LUBUMBASHI: 'AFRICA_LUBUMBASHI',
  AFRICA_LUSAKA: 'AFRICA_LUSAKA',
  AFRICA_MALABO: 'AFRICA_MALABO',
  AFRICA_MAPUTO: 'AFRICA_MAPUTO',
  AFRICA_MASERU: 'AFRICA_MASERU',
  AFRICA_MBABANE: 'AFRICA_MBABANE',
  AFRICA_MOGADISHU: 'AFRICA_MOGADISHU',
  AFRICA_MONROVIA: 'AFRICA_MONROVIA',
  AFRICA_NAIROBI: 'AFRICA_NAIROBI',
  AFRICA_NDJAMENA: 'AFRICA_NDJAMENA',
  AFRICA_NIAMEY: 'AFRICA_NIAMEY',
  AFRICA_NOUAKCHOTT: 'AFRICA_NOUAKCHOTT',
  AFRICA_OUAGADOUGOU: 'AFRICA_OUAGADOUGOU',
  AFRICA_PORTONOVO: 'AFRICA_PORTONOVO',
  AFRICA_SAOTOME: 'AFRICA_SAOTOME',
  AFRICA_TRIPOLI: 'AFRICA_TRIPOLI',
  AFRICA_TUNIS: 'AFRICA_TUNIS',
  AFRICA_WINDHOEK: 'AFRICA_WINDHOEK',
  AMERICA_ADAK: 'AMERICA_ADAK',
  AMERICA_ANCHORAGE: 'AMERICA_ANCHORAGE',
  AMERICA_ANGUILLA: 'AMERICA_ANGUILLA',
  AMERICA_ANTIGUA: 'AMERICA_ANTIGUA',
  AMERICA_ARAGUAINA: 'AMERICA_ARAGUAINA',
  AMERICA_ARGENTINA_LARIOJA: 'AMERICA_ARGENTINA_LARIOJA',
  AMERICA_ARGENTINA_RIOGALLEGOS: 'AMERICA_ARGENTINA_RIOGALLEGOS',
  AMERICA_ARGENTINA_SANJUAN: 'AMERICA_ARGENTINA_SANJUAN',
  AMERICA_ARGENTINA_TUCUMAN: 'AMERICA_ARGENTINA_TUCUMAN',
  AMERICA_ARGENTINA_USHUAIA: 'AMERICA_ARGENTINA_USHUAIA',
  AMERICA_ARUBA: 'AMERICA_ARUBA',
  AMERICA_ASUNCION: 'AMERICA_ASUNCION',
  AMERICA_BAHIA: 'AMERICA_BAHIA',
  AMERICA_BARBADOS: 'AMERICA_BARBADOS',
  AMERICA_BELEM: 'AMERICA_BELEM',
  AMERICA_BELIZE: 'AMERICA_BELIZE',
  AMERICA_BLANCSABLON: 'AMERICA_BLANCSABLON',
  AMERICA_BOAVISTA: 'AMERICA_BOAVISTA',
  AMERICA_BOGOTA: 'AMERICA_BOGOTA',
  AMERICA_BOISE: 'AMERICA_BOISE',
  AMERICA_BUENOSAIRES: 'AMERICA_BUENOSAIRES',
  AMERICA_CAMBRIDGEBAY: 'AMERICA_CAMBRIDGEBAY',
  AMERICA_CAMPOGRANDE: 'AMERICA_CAMPOGRANDE',
  AMERICA_CANCUN: 'AMERICA_CANCUN',
  AMERICA_CARACAS: 'AMERICA_CARACAS',
  AMERICA_CATAMARCA: 'AMERICA_CATAMARCA',
  AMERICA_CAYENNE: 'AMERICA_CAYENNE',
  AMERICA_CAYMAN: 'AMERICA_CAYMAN',
  AMERICA_CHICAGO: 'AMERICA_CHICAGO',
  AMERICA_CHIHUAHUA: 'AMERICA_CHIHUAHUA',
  AMERICA_CORALHARBOUR: 'AMERICA_CORALHARBOUR',
  AMERICA_CORDOBA: 'AMERICA_CORDOBA',
  AMERICA_COSTARICA: 'AMERICA_COSTARICA',
  AMERICA_CUIABA: 'AMERICA_CUIABA',
  AMERICA_CURACAO: 'AMERICA_CURACAO',
  AMERICA_DANMARKSHAVN: 'AMERICA_DANMARKSHAVN',
  AMERICA_DAWSON: 'AMERICA_DAWSON',
  AMERICA_DAWSONCREEK: 'AMERICA_DAWSONCREEK',
  AMERICA_DENVER: 'AMERICA_DENVER',
  AMERICA_DETROIT: 'AMERICA_DETROIT',
  AMERICA_DOMINICA: 'AMERICA_DOMINICA',
  AMERICA_EDMONTON: 'AMERICA_EDMONTON',
  AMERICA_EIRUNEPE: 'AMERICA_EIRUNEPE',
  AMERICA_ELSALVADOR: 'AMERICA_ELSALVADOR',
  AMERICA_FORTALEZA: 'AMERICA_FORTALEZA',
  AMERICA_GLACEBAY: 'AMERICA_GLACEBAY',
  AMERICA_GODTHAB: 'AMERICA_GODTHAB',
  AMERICA_GOOSEBAY: 'AMERICA_GOOSEBAY',
  AMERICA_GRANDTURK: 'AMERICA_GRANDTURK',
  AMERICA_GRENADA: 'AMERICA_GRENADA',
  AMERICA_GUADELOUPE: 'AMERICA_GUADELOUPE',
  AMERICA_GUATEMALA: 'AMERICA_GUATEMALA',
  AMERICA_GUAYAQUIL: 'AMERICA_GUAYAQUIL',
  AMERICA_GUYANA: 'AMERICA_GUYANA',
  AMERICA_HALIFAX: 'AMERICA_HALIFAX',
  AMERICA_HAVANA: 'AMERICA_HAVANA',
  AMERICA_HERMOSILLO: 'AMERICA_HERMOSILLO',
  AMERICA_INDIANAKNOX: 'AMERICA_INDIANAKNOX',
  AMERICA_INDIANAMARENGO: 'AMERICA_INDIANAMARENGO',
  AMERICA_INDIANAPETERSBURG: 'AMERICA_INDIANAPETERSBURG',
  AMERICA_INDIANAPOLIS: 'AMERICA_INDIANAPOLIS',
  AMERICA_INDIANAVEVAY: 'AMERICA_INDIANAVEVAY',
  AMERICA_INDIANAVINCENNES: 'AMERICA_INDIANAVINCENNES',
  AMERICA_INUVIK: 'AMERICA_INUVIK',
  AMERICA_IQALUIT: 'AMERICA_IQALUIT',
  AMERICA_JAMAICA: 'AMERICA_JAMAICA',
  AMERICA_JUJUY: 'AMERICA_JUJUY',
  AMERICA_JUNEAU: 'AMERICA_JUNEAU',
  AMERICA_KENTUCKYMONTICELLO: 'AMERICA_KENTUCKYMONTICELLO',
  AMERICA_LAPAZ: 'AMERICA_LAPAZ',
  AMERICA_LIMA: 'AMERICA_LIMA',
  AMERICA_LOSANGELES: 'AMERICA_LOSANGELES', // CB-8738
  AMERICA_LOUISVILLE: 'AMERICA_LOUISVILLE',
  AMERICA_MACEIO: 'AMERICA_MACEIO',
  AMERICA_MANAGUA: 'AMERICA_MANAGUA',
  AMERICA_MANAUS: 'AMERICA_MANAUS',
  AMERICA_MARTINIQUE: 'AMERICA_MARTINIQUE',
  AMERICA_MAZATLAN: 'AMERICA_MAZATLAN',
  AMERICA_MENDOZA: 'AMERICA_MENDOZA',
  AMERICA_MENOMINEE: 'AMERICA_MENOMINEE',
  AMERICA_MERIDA: 'AMERICA_MERIDA',
  AMERICA_MEXICOCITY: 'AMERICA_MEXICOCITY',
  AMERICA_MIQUELON: 'AMERICA_MIQUELON',
  AMERICA_MONCTON: 'AMERICA_MONCTON',
  AMERICA_MONTERREY: 'AMERICA_MONTERREY',
  AMERICA_MONTEVIDEO: 'AMERICA_MONTEVIDEO',
  AMERICA_MONTREAL: 'AMERICA_MONTREAL',
  AMERICA_MONTSERRAT: 'AMERICA_MONTSERRAT',
  AMERICA_NASSAU: 'AMERICA_NASSAU',
  AMERICA_NEWYORK: 'AMERICA_NEWYORK',
  AMERICA_NIPIGON: 'AMERICA_NIPIGON',
  AMERICA_NOME: 'AMERICA_NOME',
  AMERICA_NORONHA: 'AMERICA_NORONHA',
  AMERICA_NORTHDAKOTACENTER: 'AMERICA_NORTHDAKOTACENTER',
  AMERICA_NORTHDAKOTANEWSALEM: 'AMERICA_NORTHDAKOTANEWSALEM',
  AMERICA_PANAMA: 'AMERICA_PANAMA',
  AMERICA_PANGNIRTUNG: 'AMERICA_PANGNIRTUNG',
  AMERICA_PARAMARIBO: 'AMERICA_PARAMARIBO',
  AMERICA_PHOENIX: 'AMERICA_PHOENIX',
  AMERICA_PORTAUPRINCE: 'AMERICA_PORTAUPRINCE',
  AMERICA_PORTOFSPAIN: 'AMERICA_PORTOFSPAIN',
  AMERICA_PORTOVELHO: 'AMERICA_PORTOVELHO',
  AMERICA_PUERTORICO: 'AMERICA_PUERTORICO',
  AMERICA_RAINYRIVER: 'AMERICA_RAINYRIVER',
  AMERICA_RANKININLET: 'AMERICA_RANKININLET',
  AMERICA_RECIFE: 'AMERICA_RECIFE',
  AMERICA_REGINA: 'AMERICA_REGINA',
  AMERICA_RIOBRANCO: 'AMERICA_RIOBRANCO',
  AMERICA_SANTIAGO: 'AMERICA_SANTIAGO',
  AMERICA_SANTODOMINGO: 'AMERICA_SANTODOMINGO',
  AMERICA_SAOPAULO: 'AMERICA_SAOPAULO',
  AMERICA_SCORESBYSUND: 'AMERICA_SCORESBYSUND',
  AMERICA_SHIPROCK: 'AMERICA_SHIPROCK',
  AMERICA_STJOHNS: 'AMERICA_STJOHNS',
  AMERICA_STKITTS: 'AMERICA_STKITTS',
  AMERICA_STLUCIA: 'AMERICA_STLUCIA',
  AMERICA_STTHOMAS: 'AMERICA_STTHOMAS',
  AMERICA_STVINCENT: 'AMERICA_STVINCENT',
  AMERICA_SWIFTCURRENT: 'AMERICA_SWIFTCURRENT',
  AMERICA_TEGUCIGALPA: 'AMERICA_TEGUCIGALPA',
  AMERICA_THULE: 'AMERICA_THULE',
  AMERICA_THUNDERBAY: 'AMERICA_THUNDERBAY',
  AMERICA_TIJUANA: 'AMERICA_TIJUANA',
  AMERICA_TORONTO: 'AMERICA_TORONTO',
  AMERICA_TORTOLA: 'AMERICA_TORTOLA',
  AMERICA_VANCOUVER: 'AMERICA_VANCOUVER',
  AMERICA_WHITEHORSE: 'AMERICA_WHITEHORSE',
  AMERICA_WINNIPEG: 'AMERICA_WINNIPEG',
  AMERICA_YAKUTAT: 'AMERICA_YAKUTAT',
  AMERICA_YELLOWKNIFE: 'AMERICA_YELLOWKNIFE',
  ANTARCTICA_CASEY: 'ANTARCTICA_CASEY',
  ANTARCTICA_DAVIS: 'ANTARCTICA_DAVIS',
  ANTARCTICA_DUMONTDURVILLE: 'ANTARCTICA_DUMONTDURVILLE',
  ANTARCTICA_MAWSON: 'ANTARCTICA_MAWSON',
  ANTARCTICA_MCMURDO: 'ANTARCTICA_MCMURDO',
  ANTARCTICA_PALMER: 'ANTARCTICA_PALMER',
  ANTARCTICA_ROTHERA: 'ANTARCTICA_ROTHERA',
  ANTARCTICA_SYOWA: 'ANTARCTICA_SYOWA',
  ANTARCTICA_VOSTOK: 'ANTARCTICA_VOSTOK',
  ASIA_ADEN: 'ASIA_ADEN',
  ASIA_ALMATY: 'ASIA_ALMATY',
  ASIA_AMMAN: 'ASIA_AMMAN',
  ASIA_ANADYR: 'ASIA_ANADYR',
  ASIA_AQTAU: 'ASIA_AQTAU',
  ASIA_AQTOBE: 'ASIA_AQTOBE',
  ASIA_ASHGABAT: 'ASIA_ASHGABAT',
  ASIA_BAGHDAD: 'ASIA_BAGHDAD',
  ASIA_BAHRAIN: 'ASIA_BAHRAIN',
  ASIA_BAKU: 'ASIA_BAKU',
  ASIA_BANGKOK: 'ASIA_BANGKOK',
  ASIA_BEIRUT: 'ASIA_BEIRUT',
  ASIA_BISHKEK: 'ASIA_BISHKEK',
  ASIA_BRUNEI: 'ASIA_BRUNEI',
  ASIA_CALCUTTA: 'ASIA_CALCUTTA',
  ASIA_CHOIBALSAN: 'ASIA_CHOIBALSAN',
  ASIA_CHONGQING: 'ASIA_CHONGQING',
  ASIA_COLOMBO: 'ASIA_COLOMBO',
  ASIA_DAMASCUS: 'ASIA_DAMASCUS',
  ASIA_DHAKA: 'ASIA_DHAKA',
  ASIA_DILI: 'ASIA_DILI',
  ASIA_DUBAI: 'ASIA_DUBAI',
  ASIA_DUSHANBE: 'ASIA_DUSHANBE',
  ASIA_GAZA: 'ASIA_GAZA',
  ASIA_HARBIN: 'ASIA_HARBIN',
  ASIA_HONGKONG: 'ASIA_HONGKONG',
  ASIA_HOVD: 'ASIA_HOVD',
  ASIA_IRKUTSK: 'ASIA_IRKUTSK',
  ASIA_JAKARTA: 'ASIA_JAKARTA',
  ASIA_JAYAPURA: 'ASIA_JAYAPURA',
  ASIA_JERUSALEM: 'ASIA_JERUSALEM',
  ASIA_KABUL: 'ASIA_KABUL',
  ASIA_KAMCHATKA: 'ASIA_KAMCHATKA',
  ASIA_KARACHI: 'ASIA_KARACHI',
  ASIA_KASHGAR: 'ASIA_KASHGAR',
  ASIA_KATMANDU: 'ASIA_KATMANDU',
  ASIA_KRASNOYARSK: 'ASIA_KRASNOYARSK',
  ASIA_KUALALUMPUR: 'ASIA_KUALALUMPUR',
  ASIA_KUCHING: 'ASIA_KUCHING',
  ASIA_KUWAIT: 'ASIA_KUWAIT',
  ASIA_MACAU: 'ASIA_MACAU',
  ASIA_MAGADAN: 'ASIA_MAGADAN',
  ASIA_MAKASSAR: 'ASIA_MAKASSAR',
  ASIA_MANILA: 'ASIA_MANILA',
  ASIA_MUSCAT: 'ASIA_MUSCAT',
  ASIA_NICOSIA: 'ASIA_NICOSIA',
  ASIA_NOVOSIBIRSK: 'ASIA_NOVOSIBIRSK',
  ASIA_OMSK: 'ASIA_OMSK',
  ASIA_ORAL: 'ASIA_ORAL',
  ASIA_PHNOMPENH: 'ASIA_PHNOMPENH',
  ASIA_PONTIANAK: 'ASIA_PONTIANAK',
  ASIA_PYONGYANG: 'ASIA_PYONGYANG',
  ASIA_QATAR: 'ASIA_QATAR',
  ASIA_QYZYLORDA: 'ASIA_QYZYLORDA',
  ASIA_RANGOON: 'ASIA_RANGOON',
  ASIA_RIYADH: 'ASIA_RIYADH',
  ASIA_SAIGON: 'ASIA_SAIGON',
  ASIA_SAKHALIN: 'ASIA_SAKHALIN',
  ASIA_SAMARKAND: 'ASIA_SAMARKAND',
  ASIA_SEOUL: 'ASIA_SEOUL',
  ASIA_SHANGHAI: 'ASIA_SHANGHAI',
  ASIA_SINGAPORE: 'ASIA_SINGAPORE',
  ASIA_TAIPEI: 'ASIA_TAIPEI',
  ASIA_TASHKENT: 'ASIA_TASHKENT',
  ASIA_TBILISI: 'ASIA_TBILISI',
  ASIA_TEHRAN: 'ASIA_TEHRAN',
  ASIA_THIMPHU: 'ASIA_THIMPHU',
  ASIA_TOKYO: 'ASIA_TOKYO',
  ASIA_ULAANBAATAR: 'ASIA_ULAANBAATAR',
  ASIA_URUMQI: 'ASIA_URUMQI',
  ASIA_VIENTIANE: 'ASIA_VIENTIANE',
  ASIA_VLADIVOSTOK: 'ASIA_VLADIVOSTOK',
  ASIA_YAKUTSK: 'ASIA_YAKUTSK',
  ASIA_YEKATERINBURG: 'ASIA_YEKATERINBURG',
  ASIA_YEREVAN: 'ASIA_YEREVAN',
  ATLANTIC_AZORES: 'ATLANTIC_AZORES',
  ATLANTIC_BERMUDA: 'ATLANTIC_BERMUDA',
  ATLANTIC_CANARY: 'ATLANTIC_CANARY',
  ATLANTIC_CAPEVERDE: 'ATLANTIC_CAPEVERDE',
  ATLANTIC_FAEROE: 'ATLANTIC_FAEROE',
  ATLANTIC_MADEIRA: 'ATLANTIC_MADEIRA',
  ATLANTIC_REYKJAVIK: 'ATLANTIC_REYKJAVIK',
  ATLANTIC_SOUTHGEORGIA: 'ATLANTIC_SOUTHGEORGIA',
  ATLANTIC_STANLEY: 'ATLANTIC_STANLEY',
  ATLANTIC_STHELENA: 'ATLANTIC_STHELENA',
  AUSTRALIA_ADELAIDE: 'AUSTRALIA_ADELAIDE',
  AUSTRALIA_BRISBANE: 'AUSTRALIA_BRISBANE',
  AUSTRALIA_BROKENHILL: 'AUSTRALIA_BROKENHILL',
  AUSTRALIA_CURRIE: 'AUSTRALIA_CURRIE',
  AUSTRALIA_DARWIN: 'AUSTRALIA_DARWIN',
  AUSTRALIA_EUCLA: 'AUSTRALIA_EUCLA',
  AUSTRALIA_HOBART: 'AUSTRALIA_HOBART',
  AUSTRALIA_LINDEMAN: 'AUSTRALIA_LINDEMAN',
  AUSTRALIA_LORDHOWE: 'AUSTRALIA_LORDHOWE',
  AUSTRALIA_MELBOURNE: 'AUSTRALIA_MELBOURNE',
  AUSTRALIA_PERTH: 'AUSTRALIA_PERTH',
  AUSTRALIA_SYDNEY: 'AUSTRALIA_SYDNEY',
  EUROPE_AMSTERDAM: 'EUROPE_AMSTERDAM',
  EUROPE_ANDORRA: 'EUROPE_ANDORRA',
  EUROPE_ATHENS: 'EUROPE_ATHENS',
  EUROPE_BELGRADE: 'EUROPE_BELGRADE',
  EUROPE_BERLIN: 'EUROPE_BERLIN',
  EUROPE_BRATISLAVA: 'EUROPE_BRATISLAVA',
  EUROPE_BRUSSELS: 'EUROPE_BRUSSELS',
  EUROPE_BUCHAREST: 'EUROPE_BUCHAREST',
  EUROPE_BUDAPEST: 'EUROPE_BUDAPEST',
  EUROPE_CHISINAU: 'EUROPE_CHISINAU',
  EUROPE_COPENHAGEN: 'EUROPE_COPENHAGEN',
  EUROPE_DUBLIN: 'EUROPE_DUBLIN',
  EUROPE_GIBRALTAR: 'EUROPE_GIBRALTAR',
  EUROPE_HELSINKI: 'EUROPE_HELSINKI',
  EUROPE_ISTANBUL: 'EUROPE_ISTANBUL',
  EUROPE_KALININGRAD: 'EUROPE_KALININGRAD',
  EUROPE_KIEV: 'EUROPE_KIEV',
  EUROPE_LISBON: 'EUROPE_LISBON',
  EUROPE_LJUBLJANA: 'EUROPE_LJUBLJANA',
  EUROPE_LONDON: 'EUROPE_LONDON',
  EUROPE_LUXEMBOURG: 'EUROPE_LUXEMBOURG',
  EUROPE_MADRID: 'EUROPE_MADRID',
  EUROPE_MALTA: 'EUROPE_MALTA',
  EUROPE_MINSK: 'EUROPE_MINSK',
  EUROPE_MONACO: 'EUROPE_MONACO',
  EUROPE_MOSCOW: 'EUROPE_MOSCOW',
  EUROPE_OSLO: 'EUROPE_OSLO',
  EUROPE_PARIS: 'EUROPE_PARIS',
  EUROPE_PODGORICA: 'EUROPE_PODGORICA',
  EUROPE_PRAGUE: 'EUROPE_PRAGUE',
  EUROPE_RIGA: 'EUROPE_RIGA',
  EUROPE_ROME: 'EUROPE_ROME',
  EUROPE_SAMARA: 'EUROPE_SAMARA',
  EUROPE_SARAJEVO: 'EUROPE_SARAJEVO',
  EUROPE_SIMFEROPOL: 'EUROPE_SIMFEROPOL',
  EUROPE_SKOPJE: 'EUROPE_SKOPJE',
  EUROPE_SOFIA: 'EUROPE_SOFIA',
  EUROPE_STOCKHOLM: 'EUROPE_STOCKHOLM',
  EUROPE_TALLINN: 'EUROPE_TALLINN',
  EUROPE_TIRANE: 'EUROPE_TIRANE',
  EUROPE_UZHGOROD: 'EUROPE_UZHGOROD',
  EUROPE_VADUZ: 'EUROPE_VADUZ',
  EUROPE_VIENNA: 'EUROPE_VIENNA',
  EUROPE_VILNIUS: 'EUROPE_VILNIUS',
  EUROPE_VOLGOGRAD: 'EUROPE_VOLGOGRAD',
  EUROPE_WARSAW: 'EUROPE_WARSAW',
  EUROPE_ZAGREB: 'EUROPE_ZAGREB',
  EUROPE_ZAPOROZHYE: 'EUROPE_ZAPOROZHYE',
  EUROPE_ZURICH: 'EUROPE_ZURICH',
  INDIAN_ANTANANARIVO: 'INDIAN_ANTANANARIVO',
  INDIAN_CHAGOS: 'INDIAN_CHAGOS',
  INDIAN_CHRISTMAS: 'INDIAN_CHRISTMAS',
  INDIAN_COCOS: 'INDIAN_COCOS',
  INDIAN_COMORO: 'INDIAN_COMORO',
  INDIAN_KERGUELEN: 'INDIAN_KERGUELEN',
  INDIAN_MAHE: 'INDIAN_MAHE',
  INDIAN_MALDIVES: 'INDIAN_MALDIVES',
  INDIAN_MAURITIUS: 'INDIAN_MAURITIUS',
  INDIAN_MAYOTTE: 'INDIAN_MAYOTTE',
  INDIAN_REUNION: 'INDIAN_REUNION',
  PACIFIC_APIA: 'PACIFIC_APIA',
  PACIFIC_AUCKLAND: 'PACIFIC_AUCKLAND',
  PACIFIC_CHATHAM: 'PACIFIC_CHATHAM',
  PACIFIC_EASTER: 'PACIFIC_EASTER',
  PACIFIC_EFATE: 'PACIFIC_EFATE',
  PACIFIC_ENDERBURY: 'PACIFIC_ENDERBURY',
  PACIFIC_FAKAOFO: 'PACIFIC_FAKAOFO',
  PACIFIC_FIJI: 'PACIFIC_FIJI',
  PACIFIC_FUNAFUTI: 'PACIFIC_FUNAFUTI',
  PACIFIC_GALAPAGOS: 'PACIFIC_GALAPAGOS',
  PACIFIC_GAMBIER: 'PACIFIC_GAMBIER',
  PACIFIC_GUADALCANAL: 'PACIFIC_GUADALCANAL',
  PACIFIC_GUAM: 'PACIFIC_GUAM',
  PACIFIC_HONOLULU: 'PACIFIC_HONOLULU',
  PACIFIC_JOHNSTON: 'PACIFIC_JOHNSTON',
  PACIFIC_KIRITIMATI: 'PACIFIC_KIRITIMATI',
  PACIFIC_KOSRAE: 'PACIFIC_KOSRAE',
  PACIFIC_KWAJALEIN: 'PACIFIC_KWAJALEIN',
  PACIFIC_MAJURO: 'PACIFIC_MAJURO',
  PACIFIC_MARQUESAS: 'PACIFIC_MARQUESAS',
  PACIFIC_MIDWAY: 'PACIFIC_MIDWAY',
  PACIFIC_NAURU: 'PACIFIC_NAURU',
  PACIFIC_NIUE: 'PACIFIC_NIUE',
  PACIFIC_NORFOLK: 'PACIFIC_NORFOLK',
  PACIFIC_NOUMEA: 'PACIFIC_NOUMEA',
  PACIFIC_PAGOPAGO: 'PACIFIC_PAGOPAGO',
  PACIFIC_PALAU: 'PACIFIC_PALAU',
  PACIFIC_PITCAIRN: 'PACIFIC_PITCAIRN',
  PACIFIC_PONAPE: 'PACIFIC_PONAPE',
  PACIFIC_PORTMORESBY: 'PACIFIC_PORTMORESBY',
  PACIFIC_RAROTONGA: 'PACIFIC_RAROTONGA',
  PACIFIC_SAIPAN: 'PACIFIC_SAIPAN',
  PACIFIC_TAHITI: 'PACIFIC_TAHITI',
  PACIFIC_TARAWA: 'PACIFIC_TARAWA',
  PACIFIC_TONGATAPU: 'PACIFIC_TONGATAPU',
  PACIFIC_TRUK: 'PACIFIC_TRUK',
  PACIFIC_WAKE: 'PACIFIC_WAKE',
  PACIFIC_WALLIS: 'PACIFIC_WALLIS'
})

export type TimeZoneStrings = typeof TimeZone[keyof typeof TimeZone]

const AvailableTimeZones: TimeZoneStrings[] = [
  TimeZone.AFRICA_ABIDJAN,
  TimeZone.AMERICA_ADAK,
  TimeZone.AFRICA_ADDISABABA,
  TimeZone.AUSTRALIA_ADELAIDE,
  TimeZone.AFRICA_ALGIERS,
  TimeZone.EUROPE_AMSTERDAM,
  TimeZone.ASIA_ANADYR,
  TimeZone.AMERICA_ANCHORAGE,
  TimeZone.AMERICA_ARAGUAINA,
  TimeZone.PACIFIC_AUCKLAND,
  TimeZone.ATLANTIC_AZORES,
  TimeZone.ASIA_BANGKOK,
  TimeZone.ASIA_BEIRUT,
  TimeZone.EUROPE_BELGRADE,
  TimeZone.AMERICA_BELIZE,
  TimeZone.EUROPE_BERLIN,
  TimeZone.AFRICA_BLANTYRE,
  TimeZone.AMERICA_BOGOTA,
  TimeZone.AUSTRALIA_BRISBANE,
  TimeZone.EUROPE_BRUSSELS,
  TimeZone.AMERICA_BUENOSAIRES,
  TimeZone.AFRICA_CAIRO,
  TimeZone.ASIA_CALCUTTA,
  TimeZone.AMERICA_CAMPOGRANDE,
  TimeZone.AMERICA_CANCUN,
  TimeZone.ATLANTIC_CAPEVERDE,
  TimeZone.AMERICA_CARACAS,
  TimeZone.PACIFIC_CHATHAM,
  TimeZone.AMERICA_CHICAGO,
  TimeZone.AMERICA_CHIHUAHUA,
  TimeZone.ASIA_DAMASCUS,
  TimeZone.AUSTRALIA_DARWIN,
  TimeZone.AMERICA_DENVER,
  TimeZone.ASIA_DHAKA,
  TimeZone.ASIA_DUBAI,
  TimeZone.EUROPE_DUBLIN,
  TimeZone.AUSTRALIA_EUCLA,
  TimeZone.PACIFIC_FIJI,
  TimeZone.PACIFIC_GAMBIER,
  TimeZone.ASIA_GAZA,
  TimeZone.AMERICA_GLACEBAY,
  TimeZone.GMT,
  TimeZone.AMERICA_GODTHAB,
  TimeZone.AMERICA_GOOSEBAY,
  TimeZone.AMERICA_HAVANA,
  TimeZone.AUSTRALIA_HOBART,
  TimeZone.ASIA_HONGKONG,
  TimeZone.PACIFIC_HONOLULU,
  TimeZone.ASIA_IRKUTSK,
  TimeZone.ASIA_JAKARTA,
  TimeZone.ASIA_JERUSALEM,
  TimeZone.ASIA_KABUL,
  TimeZone.ASIA_KATMANDU,
  TimeZone.PACIFIC_KIRITIMATI,
  TimeZone.AMERICA_LAPAZ,
  TimeZone.EUROPE_LISBON,
  TimeZone.EUROPE_LONDON,
  TimeZone.AUSTRALIA_LORDHOWE,
  TimeZone.AMERICA_LOSANGELES,
  TimeZone.EUROPE_MADRID,
  TimeZone.ASIA_MAGADAN,
  TimeZone.PACIFIC_MARQUESAS,
  TimeZone.AMERICA_MEXICOCITY,
  TimeZone.PACIFIC_MIDWAY,
  TimeZone.EUROPE_MINSK,
  TimeZone.AMERICA_MIQUELON,
  TimeZone.AMERICA_MONTEVIDEO,
  TimeZone.EUROPE_MOSCOW,
  TimeZone.AMERICA_NEWYORK,
  TimeZone.PACIFIC_NORFOLK,
  TimeZone.AMERICA_NORONHA,
  TimeZone.ASIA_NOVOSIBIRSK,
  TimeZone.EUROPE_PARIS,
  TimeZone.AUSTRALIA_PERTH,
  TimeZone.AMERICA_PHOENIX,
  TimeZone.PACIFIC_PITCAIRN,
  TimeZone.ASIA_RANGOON,
  TimeZone.EUROPE_ROME,
  TimeZone.AMERICA_SANTIAGO,
  TimeZone.AMERICA_SAOPAULO,
  TimeZone.ASIA_SEOUL,
  TimeZone.ASIA_SHANGHAI,
  TimeZone.ASIA_SINGAPORE,
  TimeZone.ATLANTIC_STANLEY,
  TimeZone.AMERICA_STJOHNS,
  TimeZone.AUSTRALIA_SYDNEY,
  TimeZone.ASIA_TAIPEI,
  TimeZone.ASIA_TASHKENT,
  TimeZone.ASIA_TEHRAN,
  TimeZone.AMERICA_TIJUANA,
  TimeZone.PACIFIC_TONGATAPU,
  TimeZone.ASIA_TOKYO,
  TimeZone.ASIA_VLADIVOSTOK,
  TimeZone.AFRICA_WINDHOEK,
  TimeZone.ASIA_YAKUTSK,
  TimeZone.ASIA_YEKATERINBURG
]
const TimeZoneInfo: { [key in TimeZoneStrings]: string[] } = {
  GMT: ['Etc/GMT', 'GMT'],
  AFRICA_ABIDJAN: ['Africa/Abidjan', 'Abidjan'],
  AFRICA_ACCRA: ['Africa/Accra', 'Accra'],
  AFRICA_ADDISABABA: ['Africa/Addis_Ababa', 'Addis Ababa'],
  AFRICA_ALGIERS: ['Africa/Algiers', 'Algiers'],
  AFRICA_ASMERA: ['Africa/Asmara', 'Asmera'],
  AFRICA_BAMAKO: ['Africa/Bamako', 'Bamako'],
  AFRICA_BANGUI: ['Africa/Bangui', 'Bangui'],
  AFRICA_BANJUL: ['Africa/Banjul', 'Banjul'],
  AFRICA_BISSAU: ['Africa/Bissau', 'Bissau'],
  AFRICA_BLANTYRE: ['Africa/Blantyre', 'Blantyre'],
  AFRICA_BRAZZAVILLE: ['Africa/Brazzaville', 'Brazzaville'],
  AFRICA_BUJUMBURA: ['Africa/Bujumbura', 'Bujumbura'],
  AFRICA_CAIRO: ['Africa/Cairo', 'Cairo'],
  AFRICA_CASABLANCA: ['Africa/Casablanca', 'Casablanca'],
  AFRICA_CEUTA: ['Africa/Ceuta', 'Ceuta'],
  AFRICA_CONAKRY: ['Africa/Conakry', 'Conakry'],
  AFRICA_DAKAR: ['Africa/Dakar', 'Dakar'],
  AFRICA_DARESSALAAM: ['Africa/Dar_es_Salaam', 'Dar es Salaam'],
  AFRICA_DJIBOUTI: ['Africa/Djibouti', 'Djibouti'],
  AFRICA_DOUALA: ['Africa/Douala', 'Douala'],
  AFRICA_ELAAIUN: ['Africa/El_Aaiun', 'El Aaiun'],
  AFRICA_FREETOWN: ['Africa/Freetown', 'Freetown'],
  AFRICA_GABORONE: ['Africa/Gaborone', 'Gaborone'],
  AFRICA_HARARE: ['Africa/Harare', 'Harare'],
  AFRICA_JOHANNESBURG: ['Africa/Johannesburg', 'Johannesburg'],
  AFRICA_KAMPALA: ['Africa/Kampala', 'Kampala'],
  AFRICA_KHARTOUM: ['Africa/Khartoum', 'Khartoum'],
  AFRICA_KIGALI: ['Africa/Kigali', 'Kigali'],
  AFRICA_KINSHASA: ['Africa/Kinshasa', 'Kinshasa'],
  AFRICA_LAGOS: ['Africa/Lagos', 'Lagos'],
  AFRICA_LIBREVILLE: ['Africa/Libreville', 'Libreville'],
  AFRICA_LOME: ['Africa/Lome', 'Lome'],
  AFRICA_LUANDA: ['Africa/Luanda', 'Luanda'],
  AFRICA_LUBUMBASHI: ['Africa/Lubumbashi', 'Lubumbashi'],
  AFRICA_LUSAKA: ['Africa/Lusaka', 'Lusaka'],
  AFRICA_MALABO: ['Africa/Malabo', 'Malabo'],
  AFRICA_MAPUTO: ['Africa/Maputo', 'Maputo'],
  AFRICA_MASERU: ['Africa/Maseru', 'Maseru'],
  AFRICA_MBABANE: ['Africa/Mbabane', 'Mbabane'],
  AFRICA_MOGADISHU: ['Africa/Mogadishu', 'Mogadishu'],
  AFRICA_MONROVIA: ['Africa/Monrovia', 'Monrovia'],
  AFRICA_NAIROBI: ['Africa/Nairobi', 'Nairobi'],
  AFRICA_NDJAMENA: ['Africa/Ndjamena', 'Ndjamena'],
  AFRICA_NIAMEY: ['Africa/Niamey', 'Niamey'],
  AFRICA_NOUAKCHOTT: ['Africa/Nouakchott', 'Nouakchott'],
  AFRICA_OUAGADOUGOU: ['Africa/Ouagadougou', 'Ouagadougou'],
  AFRICA_PORTONOVO: ['Africa/Porto-Novo', 'Porto Novo'],
  AFRICA_SAOTOME: ['Africa/Sao_Tome', 'Sao Tome'],
  AFRICA_TRIPOLI: ['Africa/Tripoli', 'Tripoli'],
  AFRICA_TUNIS: ['Africa/Tunis', 'Tunis'],
  AFRICA_WINDHOEK: ['Africa/Windhoek', 'Windhoek'],
  AMERICA_ADAK: ['America/Adak', 'Adak'],
  AMERICA_ANCHORAGE: ['America/Anchorage', 'Anchorage'],
  AMERICA_ANGUILLA: ['America/Anguilla', 'Anguilla'],
  AMERICA_ANTIGUA: ['America/Antigua', 'Antigua'],
  AMERICA_ARAGUAINA: ['America/Araguaina', 'Araguaina'],
  AMERICA_ARGENTINA_LARIOJA: ['America/Argentina/La_Rioja', 'La Rioja'],
  AMERICA_ARGENTINA_RIOGALLEGOS: ['America/Argentina/Rio_Gallegos', 'Rio Gallegos'],
  AMERICA_ARGENTINA_SANJUAN: ['America/Argentina/San_Juan', 'San Juan'],
  AMERICA_ARGENTINA_TUCUMAN: ['America/Argentina/Tucuman', 'Tucuman'],
  AMERICA_ARGENTINA_USHUAIA: ['America/Argentina/Ushuaia', 'Ushuaia'],
  AMERICA_ARUBA: ['America/Aruba', 'Aruba'],
  AMERICA_ASUNCION: ['America/Asuncion', 'Asuncion'],
  AMERICA_BAHIA: ['America/Bahia', 'Bahia'],
  AMERICA_BARBADOS: ['America/Barbados', 'Barbados'],
  AMERICA_BELEM: ['America/Belem', 'Belem'],
  AMERICA_BELIZE: ['America/Belize', 'Belize'],
  AMERICA_BLANCSABLON: ['America/Blanc-Sablon', 'Blanc Sablon'],
  AMERICA_BOAVISTA: ['America/Boa_Vista', 'Boa Vista'],
  AMERICA_BOGOTA: ['America/Bogota', 'Bogota'],
  AMERICA_BOISE: ['America/Boise', 'Boise'],
  AMERICA_BUENOSAIRES: ['America/Argentina/Buenos_Aires', 'Buenos Aires'],
  AMERICA_CAMBRIDGEBAY: ['America/Cambridge_Bay', 'Cambridge Bay'],
  AMERICA_CAMPOGRANDE: ['America/Campo_Grande', 'Campo Grande'],
  AMERICA_CANCUN: ['America/Cancun', 'Cancun'],
  AMERICA_CARACAS: ['America/Caracas', 'Caracas'],
  AMERICA_CATAMARCA: ['America/Argentina/Catamarca', 'Catamarca'],
  AMERICA_CAYENNE: ['America/Cayenne', 'Cayenne'],
  AMERICA_CAYMAN: ['America/Cayman', 'Cayman'],
  AMERICA_CHICAGO: ['America/Chicago', 'Chicago'],
  AMERICA_CHIHUAHUA: ['America/Chihuahua', 'Chihuahua'],
  AMERICA_CORALHARBOUR: ['America/Atikokan', 'Coral Harbour'],
  AMERICA_CORDOBA: ['America/Argentina/Cordoba', 'Cordoba'],
  AMERICA_COSTARICA: ['America/Costa_Rica', 'Costa Rica'],
  AMERICA_CUIABA: ['America/Cuiaba', 'Cuiaba'],
  AMERICA_CURACAO: ['America/Curacao', 'Curacao'],
  AMERICA_DANMARKSHAVN: ['America/Danmarkshavn', 'Danmarkshavn'],
  AMERICA_DAWSON: ['America/Dawson', 'Dawson'],
  AMERICA_DAWSONCREEK: ['America/Dawson_Creek', 'Dawson Creek'],
  AMERICA_DENVER: ['America/Denver', 'Denver'],
  AMERICA_DETROIT: ['America/Detroit', 'Detroit'],
  AMERICA_DOMINICA: ['America/Dominica', 'Dominica'],
  AMERICA_EDMONTON: ['America/Edmonton', 'Edmonton'],
  AMERICA_EIRUNEPE: ['America/Eirunepe', 'Eirunepe'],
  AMERICA_ELSALVADOR: ['America/El_Salvador', 'El Salvador'],
  AMERICA_FORTALEZA: ['America/Fortaleza', 'Fortaleza'],
  AMERICA_GLACEBAY: ['America/Glace_Bay', 'Glace Bay'],
  AMERICA_GODTHAB: ['America/Godthab', 'Godthab'],
  AMERICA_GOOSEBAY: ['America/Goose_Bay', 'Goose Bay'],
  AMERICA_GRANDTURK: ['America/Grand_Turk', 'Grand Turk'],
  AMERICA_GRENADA: ['America/Grenada', 'Grenada'],
  AMERICA_GUADELOUPE: ['America/Guadeloupe', 'Guadeloupe'],
  AMERICA_GUATEMALA: ['America/Guatemala', 'Guatemala'],
  AMERICA_GUAYAQUIL: ['America/Guayaquil', 'Guayaquil'],
  AMERICA_GUYANA: ['America/Guyana', 'Guyana'],
  AMERICA_HALIFAX: ['America/Halifax', 'Halifax'],
  AMERICA_HAVANA: ['America/Havana', 'Havana'],
  AMERICA_HERMOSILLO: ['America/Hermosillo', 'Hermosillo'],
  AMERICA_INDIANAKNOX: ['America/Indiana/Knox', 'Knox'],
  AMERICA_INDIANAMARENGO: ['America/Indiana/Marengo', 'Marengo'],
  AMERICA_INDIANAPETERSBURG: ['America/Indiana/Petersburg', 'Petersburg'],
  AMERICA_INDIANAPOLIS: ['America/Indiana/Indianapolis', 'Indianapolis'],
  AMERICA_INDIANAVEVAY: ['America/Indiana/Vevay', 'Vevay'],
  AMERICA_INDIANAVINCENNES: ['America/Indiana/Vincennes', 'Vincennes'],
  AMERICA_INUVIK: ['America/Inuvik', 'Inuvik'],
  AMERICA_IQALUIT: ['America/Iqaluit', 'Iqaluit'],
  AMERICA_JAMAICA: ['America/Jamaica', 'Jamaica'],
  AMERICA_JUJUY: ['America/Argentina/Jujuy', 'Jujuy'],
  AMERICA_JUNEAU: ['America/Juneau', 'Juneau'],
  AMERICA_KENTUCKYMONTICELLO: ['America/Kentucky/Monticello', 'Monticello'],
  AMERICA_LAPAZ: ['America/La_Paz', 'La Paz'],
  AMERICA_LIMA: ['America/Lima', 'Lima'],
  AMERICA_LOSANGELES: ['America/Los_Angeles', 'Mountain View'], // CB-8738
  AMERICA_LOUISVILLE: ['America/Kentucky/Louisville', 'Louisville'],
  AMERICA_MACEIO: ['America/Maceio', 'Maceio'],
  AMERICA_MANAGUA: ['America/Managua', 'Managua'],
  AMERICA_MANAUS: ['America/Manaus', 'Manaus'],
  AMERICA_MARTINIQUE: ['America/Martinique', 'Martinique'],
  AMERICA_MAZATLAN: ['America/Mazatlan', 'Mazatlan'],
  AMERICA_MENDOZA: ['America/Argentina/Mendoza', 'Mendoza'],
  AMERICA_MENOMINEE: ['America/Menominee', 'Menominee'],
  AMERICA_MERIDA: ['America/Merida', 'Merida'],
  AMERICA_MEXICOCITY: ['America/Mexico_City', 'Mexico City'],
  AMERICA_MIQUELON: ['America/Miquelon', 'Miquelon'],
  AMERICA_MONCTON: ['America/Moncton', 'Moncton'],
  AMERICA_MONTERREY: ['America/Monterrey', 'Monterrey'],
  AMERICA_MONTEVIDEO: ['America/Montevideo', 'Montevideo'],
  AMERICA_MONTREAL: ['America/Montreal', 'Montreal'],
  AMERICA_MONTSERRAT: ['America/Montserrat', 'Montserrat'],
  AMERICA_NASSAU: ['America/Nassau', 'Nassau'],
  AMERICA_NEWYORK: ['America/New_York', 'New York'],
  AMERICA_NIPIGON: ['America/Nipigon', 'Nipigon'],
  AMERICA_NOME: ['America/Nome', 'Nome'],
  AMERICA_NORONHA: ['America/Noronha', 'Noronha'],
  AMERICA_NORTHDAKOTACENTER: ['America/North_Dakota/Center', 'Center'],
  AMERICA_NORTHDAKOTANEWSALEM: ['America/North_Dakota/New_Salem', 'New Salem'],
  AMERICA_PANAMA: ['America/Panama', 'Panama'],
  AMERICA_PANGNIRTUNG: ['America/Pangnirtung', 'Pangnirtung'],
  AMERICA_PARAMARIBO: ['America/Paramaribo', 'Paramaribo'],
  AMERICA_PHOENIX: ['America/Phoenix', 'Phoenix'],
  AMERICA_PORTAUPRINCE: ['America/Port-au-Prince', 'Port au Prince'],
  AMERICA_PORTOFSPAIN: ['America/Port_of_Spain', 'Port of Spain'],
  AMERICA_PORTOVELHO: ['America/Porto_Velho', 'Porto Velho'],
  AMERICA_PUERTORICO: ['America/Puerto_Rico', 'Puerto Rico'],
  AMERICA_RAINYRIVER: ['America/Rainy_River', 'Rainy River'],
  AMERICA_RANKININLET: ['America/Rankin_Inlet', 'Rankin Inlet'],
  AMERICA_RECIFE: ['America/Recife', 'Recife'],
  AMERICA_REGINA: ['America/Regina', 'Regina'],
  AMERICA_RIOBRANCO: ['America/Rio_Branco', 'Rio Branco'],
  AMERICA_SANTIAGO: ['America/Santiago', 'Santiago'],
  AMERICA_SANTODOMINGO: ['America/Santo_Domingo', 'Santo Domingo'],
  AMERICA_SAOPAULO: ['America/Sao_Paulo', 'Sao Paulo'],
  AMERICA_SCORESBYSUND: ['America/Scoresbysund', 'Scoresbysund'],
  AMERICA_SHIPROCK: ['America/Denver', 'Shiprock'],
  AMERICA_STJOHNS: ['America/St_Johns', 'St. Johns'],
  AMERICA_STKITTS: ['America/St_Kitts', 'St. Kitts'],
  AMERICA_STLUCIA: ['America/St_Lucia', 'St. Lucia'],
  AMERICA_STTHOMAS: ['America/St_Thomas', 'St. Thomas'],
  AMERICA_STVINCENT: ['America/St_Vincent', 'St. Vincent'],
  AMERICA_SWIFTCURRENT: ['America/Swift_Current', 'Swift Current'],
  AMERICA_TEGUCIGALPA: ['America/Tegucigalpa', 'Tegucigalpa'],
  AMERICA_THULE: ['America/Thule', 'Thule'],
  AMERICA_THUNDERBAY: ['America/Thunder_Bay', 'Thunder Bay'],
  AMERICA_TIJUANA: ['America/Tijuana', 'Tijuana'],
  AMERICA_TORONTO: ['America/Toronto', 'Toronto'],
  AMERICA_TORTOLA: ['America/Tortola', 'Tortola'],
  AMERICA_VANCOUVER: ['America/Vancouver', 'Vancouver'],
  AMERICA_WHITEHORSE: ['America/Whitehorse', 'Whitehorse'],
  AMERICA_WINNIPEG: ['America/Winnipeg', 'Winnipeg'],
  AMERICA_YAKUTAT: ['America/Yakutat', 'Yakutat'],
  AMERICA_YELLOWKNIFE: ['America/Yellowknife', 'Yellowknife'],
  ANTARCTICA_CASEY: ['Antarctica/Casey', 'Casey'],
  ANTARCTICA_DAVIS: ['Antarctica/Davis', 'Davis'],
  ANTARCTICA_DUMONTDURVILLE: ['Antarctica/DumontDUrville', "Dumont D'Urville"],
  ANTARCTICA_MAWSON: ['Antarctica/Mawson', 'Mawson'],
  ANTARCTICA_MCMURDO: ['Antarctica/McMurdo', 'McMurdo'],
  ANTARCTICA_PALMER: ['Antarctica/Palmer', 'Palmer'],
  ANTARCTICA_ROTHERA: ['Antarctica/Rothera', 'Rothera'],
  ANTARCTICA_SYOWA: ['Antarctica/Syowa', 'Syowa'],
  ANTARCTICA_VOSTOK: ['Antarctica/Vostok', 'Vostok'],
  ASIA_ADEN: ['Asia/Aden', 'Aden'],
  ASIA_ALMATY: ['Asia/Almaty', 'Almaty'],
  ASIA_AMMAN: ['Asia/Amman', 'Amman'],
  ASIA_ANADYR: ['Asia/Anadyr', 'Anadyr'],
  ASIA_AQTAU: ['Asia/Aqtau', 'Aqtau'],
  ASIA_AQTOBE: ['Asia/Aqtobe', 'Aqtobe'],
  ASIA_ASHGABAT: ['Asia/Ashgabat', 'Ashgabat'],
  ASIA_BAGHDAD: ['Asia/Baghdad', 'Baghdad'],
  ASIA_BAHRAIN: ['Asia/Bahrain', 'Bahrain'],
  ASIA_BAKU: ['Asia/Baku', 'Baku'],
  ASIA_BANGKOK: ['Asia/Bangkok', 'Bangkok'],
  ASIA_BEIRUT: ['Asia/Beirut', 'Beirut'],
  ASIA_BISHKEK: ['Asia/Bishkek', 'Bishkek'],
  ASIA_BRUNEI: ['Asia/Brunei', 'Brunei'],
  ASIA_CALCUTTA: ['Asia/Kolkata', 'Calcutta'],
  ASIA_CHOIBALSAN: ['Asia/Choibalsan', 'Choibalsan'],
  ASIA_CHONGQING: ['Asia/Chongqing', 'Chongqing'],
  ASIA_COLOMBO: ['Asia/Colombo', 'Colombo'],
  ASIA_DAMASCUS: ['Asia/Damascus', 'Damascus'],
  ASIA_DHAKA: ['Asia/Dhaka', 'Dhaka'],
  ASIA_DILI: ['Asia/Dili', 'Dili'],
  ASIA_DUBAI: ['Asia/Dubai', 'Dubai'],
  ASIA_DUSHANBE: ['Asia/Dushanbe', 'Dushanbe'],
  ASIA_GAZA: ['Asia/Gaza', 'Gaza'],
  ASIA_HARBIN: ['Asia/Harbin', 'Harbin'],
  ASIA_HONGKONG: ['Asia/Hong_Kong', 'Hong Kong'],
  ASIA_HOVD: ['Asia/Hovd', 'Hovd'],
  ASIA_IRKUTSK: ['Asia/Irkutsk', 'Irkutsk'],
  ASIA_JAKARTA: ['Asia/Jakarta', 'Jakarta'],
  ASIA_JAYAPURA: ['Asia/Jayapura', 'Jayapura'],
  ASIA_JERUSALEM: ['Asia/Jerusalem', 'Jerusalem'],
  ASIA_KABUL: ['Asia/Kabul', 'Kabul'],
  ASIA_KAMCHATKA: ['Asia/Kamchatka', 'Kamchatka'],
  ASIA_KARACHI: ['Asia/Karachi', 'Karachi'],
  ASIA_KASHGAR: ['Asia/Kashgar', 'Kashgar'],
  ASIA_KATMANDU: ['Asia/Kathmandu', 'Kathmandu'],
  ASIA_KRASNOYARSK: ['Asia/Krasnoyarsk', 'Krasnoyarsk'],
  ASIA_KUALALUMPUR: ['Asia/Kuala_Lumpur', 'Kuala Lumpur'],
  ASIA_KUCHING: ['Asia/Kuching', 'Kuching'],
  ASIA_KUWAIT: ['Asia/Kuwait', 'Kuwait'],
  ASIA_MACAU: ['Asia/Macau', 'Macau'],
  ASIA_MAGADAN: ['Asia/Magadan', 'Magadan'],
  ASIA_MAKASSAR: ['Asia/Makassar', 'Makassar'],
  ASIA_MANILA: ['Asia/Manila', 'Manila'],
  ASIA_MUSCAT: ['Asia/Muscat', 'Muscat'],
  ASIA_NICOSIA: ['Asia/Nicosia', 'Nicosia'],
  ASIA_NOVOSIBIRSK: ['Asia/Novosibirsk', 'Novosibirsk'],
  ASIA_OMSK: ['Asia/Omsk', 'Omsk'],
  ASIA_ORAL: ['Asia/Oral', 'Oral'],
  ASIA_PHNOMPENH: ['Asia/Phnom_Penh', 'Phnom Penh'],
  ASIA_PONTIANAK: ['Asia/Pontianak', 'Pontianak'],
  ASIA_PYONGYANG: ['Asia/Pyongyang', 'Pyongyang'],
  ASIA_QATAR: ['Asia/Qatar', 'Qatar'],
  ASIA_QYZYLORDA: ['Asia/Qyzylorda', 'Qyzylorda'],
  ASIA_RANGOON: ['Asia/Rangoon', 'Rangoon'],
  ASIA_RIYADH: ['Asia/Riyadh', 'Riyadh'],
  ASIA_SAIGON: ['Asia/Ho_Chi_Minh', 'Saigon'],
  ASIA_SAKHALIN: ['Asia/Sakhalin', 'Sakhalin'],
  ASIA_SAMARKAND: ['Asia/Samarkand', 'Samarkand'],
  ASIA_SEOUL: ['Asia/Seoul', 'Seoul'],
  ASIA_SHANGHAI: ['Asia/Shanghai', 'Shanghai'],
  ASIA_SINGAPORE: ['Asia/Singapore', 'Singapore'],
  ASIA_TAIPEI: ['Asia/Taipei', 'Taipei'],
  ASIA_TASHKENT: ['Asia/Tashkent', 'Tashkent'],
  ASIA_TBILISI: ['Asia/Tbilisi', 'Tbilisi'],
  ASIA_TEHRAN: ['Asia/Tehran', 'Tehran'],
  ASIA_THIMPHU: ['Asia/Thimphu', 'Thimphu'],
  ASIA_TOKYO: ['Asia/Tokyo', 'Tokyo'],
  ASIA_ULAANBAATAR: ['Asia/Ulaanbaatar', 'Ulaanbaatar'],
  ASIA_URUMQI: ['Asia/Urumqi', 'Urumqi'],
  ASIA_VIENTIANE: ['Asia/Vientiane', 'Vientiane'],
  ASIA_VLADIVOSTOK: ['Asia/Vladivostok', 'Vladivostok'],
  ASIA_YAKUTSK: ['Asia/Yakutsk', 'Yakutsk'],
  ASIA_YEKATERINBURG: ['Asia/Yekaterinburg', 'Yekaterinburg'],
  ASIA_YEREVAN: ['Asia/Yerevan', 'Yerevan'],
  ATLANTIC_AZORES: ['Atlantic/Azores', 'Azores'],
  ATLANTIC_BERMUDA: ['Atlantic/Bermuda', 'Bermuda'],
  ATLANTIC_CANARY: ['Atlantic/Canary', 'Canary'],
  ATLANTIC_CAPEVERDE: ['Atlantic/Cape_Verde', 'Cape Verde'],
  ATLANTIC_FAEROE: ['Atlantic/Faroe', 'Faeroe'],
  ATLANTIC_MADEIRA: ['Atlantic/Madeira', 'Madeira'],
  ATLANTIC_REYKJAVIK: ['Atlantic/Reykjavik', 'Reykjavik'],
  ATLANTIC_SOUTHGEORGIA: ['Atlantic/South_Georgia', 'South Georgia'],
  ATLANTIC_STANLEY: ['Atlantic/Stanley', 'Stanley'],
  ATLANTIC_STHELENA: ['Atlantic/St_Helena', 'St. Helena'],
  AUSTRALIA_ADELAIDE: ['Australia/Adelaide', 'Adelaide'],
  AUSTRALIA_BRISBANE: ['Australia/Brisbane', 'Brisbane'],
  AUSTRALIA_BROKENHILL: ['Australia/Broken_Hill', 'Broken Hill'],
  AUSTRALIA_CURRIE: ['Australia/Currie', 'Currie'],
  AUSTRALIA_DARWIN: ['Australia/Darwin', 'Darwin'],
  AUSTRALIA_EUCLA: ['Australia/Eucla', 'Eucla'],
  AUSTRALIA_HOBART: ['Australia/Hobart', 'Hobart'],
  AUSTRALIA_LINDEMAN: ['Australia/Lindeman', 'Lindeman'],
  AUSTRALIA_LORDHOWE: ['Australia/Lord_Howe', 'Lord Howe'],
  AUSTRALIA_MELBOURNE: ['Australia/Melbourne', 'Melbourne'],
  AUSTRALIA_PERTH: ['Australia/Perth', 'Perth'],
  AUSTRALIA_SYDNEY: ['Australia/Sydney', 'Sydney'],
  EUROPE_AMSTERDAM: ['Europe/Amsterdam', 'Amsterdam'],
  EUROPE_ANDORRA: ['Europe/Andorra', 'Andorra'],
  EUROPE_ATHENS: ['Europe/Athens', 'Athens'],
  EUROPE_BELGRADE: ['Europe/Belgrade', 'Belgrade'],
  EUROPE_BERLIN: ['Europe/Berlin', 'Berlin'],
  EUROPE_BRATISLAVA: ['Europe/Bratislava', 'Bratislava'],
  EUROPE_BRUSSELS: ['Europe/Brussels', 'Brussels'],
  EUROPE_BUCHAREST: ['Europe/Bucharest', 'Bucharest'],
  EUROPE_BUDAPEST: ['Europe/Budapest', 'Budapest'],
  EUROPE_CHISINAU: ['Europe/Chisinau', 'Chisinau'],
  EUROPE_COPENHAGEN: ['Europe/Copenhagen', 'Copenhagen'],
  EUROPE_DUBLIN: ['Europe/Dublin', 'Dublin'],
  EUROPE_GIBRALTAR: ['Europe/Gibraltar', 'Gibraltar'],
  EUROPE_HELSINKI: ['Europe/Helsinki', 'Helsinki'],
  EUROPE_ISTANBUL: ['Europe/Istanbul', 'Istanbul'],
  EUROPE_KALININGRAD: ['Europe/Kaliningrad', 'Kaliningrad'],
  EUROPE_KIEV: ['Europe/Kiev', 'Kiev'],
  EUROPE_LISBON: ['Europe/Lisbon', 'Lisbon'],
  EUROPE_LJUBLJANA: ['Europe/Ljubljana', 'Ljubljana'],
  EUROPE_LONDON: ['Europe/London', 'London'],
  EUROPE_LUXEMBOURG: ['Europe/Luxembourg', 'Luxembourg'],
  EUROPE_MADRID: ['Europe/Madrid', 'Madrid'],
  EUROPE_MALTA: ['Europe/Malta', 'Malta'],
  EUROPE_MINSK: ['Europe/Minsk', 'Minsk'],
  EUROPE_MONACO: ['Europe/Monaco', 'Monaco'],
  EUROPE_MOSCOW: ['Europe/Moscow', 'Moscow'],
  EUROPE_OSLO: ['Europe/Oslo', 'Oslo'],
  EUROPE_PARIS: ['Europe/Paris', 'Paris'],
  EUROPE_PODGORICA: ['Europe/Podgorica', 'Podgorica'],
  EUROPE_PRAGUE: ['Europe/Prague', 'Prague'],
  EUROPE_RIGA: ['Europe/Riga', 'Riga'],
  EUROPE_ROME: ['Europe/Rome', 'Rome'],
  EUROPE_SAMARA: ['Europe/Samara', 'Samara'],
  EUROPE_SARAJEVO: ['Europe/Sarajevo', 'Sarajevo'],
  EUROPE_SIMFEROPOL: ['Europe/Simferopol', 'Simferopol'],
  EUROPE_SKOPJE: ['Europe/Skopje', 'Skopje'],
  EUROPE_SOFIA: ['Europe/Sofia', 'Sofia'],
  EUROPE_STOCKHOLM: ['Europe/Stockholm', 'Stockholm'],
  EUROPE_TALLINN: ['Europe/Tallinn', 'Tallinn'],
  EUROPE_TIRANE: ['Europe/Tirane', 'Tirane'],
  EUROPE_UZHGOROD: ['Europe/Uzhgorod', 'Uzhgorod'],
  EUROPE_VADUZ: ['Europe/Vaduz', 'Vaduz'],
  EUROPE_VIENNA: ['Europe/Vienna', 'Vienna'],
  EUROPE_VILNIUS: ['Europe/Vilnius', 'Vilnius'],
  EUROPE_VOLGOGRAD: ['Europe/Volgograd', 'Volgograd'],
  EUROPE_WARSAW: ['Europe/Warsaw', 'Warsaw'],
  EUROPE_ZAGREB: ['Europe/Zagreb', 'Zagreb'],
  EUROPE_ZAPOROZHYE: ['Europe/Zaporozhye', 'Zaporozhye'],
  EUROPE_ZURICH: ['Europe/Zurich', 'Zurich'],
  INDIAN_ANTANANARIVO: ['Indian/Antananarivo', 'Antananarivo'],
  INDIAN_CHAGOS: ['Indian/Chagos', 'Chagos'],
  INDIAN_CHRISTMAS: ['Indian/Christmas', 'Christmas'],
  INDIAN_COCOS: ['Indian/Cocos', 'Cocos'],
  INDIAN_COMORO: ['Indian/Comoro', 'Comoro'],
  INDIAN_KERGUELEN: ['Indian/Kerguelen', 'Kerguelen'],
  INDIAN_MAHE: ['Indian/Mahe', 'Mahe'],
  INDIAN_MALDIVES: ['Indian/Maldives', 'Maldives'],
  INDIAN_MAURITIUS: ['Indian/Mauritius', 'Mauritius'],
  INDIAN_MAYOTTE: ['Indian/Mayotte', 'Mayotte'],
  INDIAN_REUNION: ['Indian/Reunion', 'Reunion'],
  PACIFIC_APIA: ['Pacific/Apia', 'Apia'],
  PACIFIC_AUCKLAND: ['Pacific/Auckland', 'Auckland'],
  PACIFIC_CHATHAM: ['Pacific/Chatham', 'Chatham'],
  PACIFIC_EASTER: ['Pacific/Easter', 'Easter'],
  PACIFIC_EFATE: ['Pacific/Efate', 'Efate'],
  PACIFIC_ENDERBURY: ['Pacific/Enderbury', 'Enderbury'],
  PACIFIC_FAKAOFO: ['Pacific/Fakaofo', 'Fakaofo'],
  PACIFIC_FIJI: ['Pacific/Fiji', 'Fiji'],
  PACIFIC_FUNAFUTI: ['Pacific/Funafuti', 'Funafuti'],
  PACIFIC_GALAPAGOS: ['Pacific/Galapagos', 'Galapagos'],
  PACIFIC_GAMBIER: ['Pacific/Gambier', 'Gambier'],
  PACIFIC_GUADALCANAL: ['Pacific/Guadalcanal', 'Guadalcanal'],
  PACIFIC_GUAM: ['Pacific/Guam', 'Guam'],
  PACIFIC_HONOLULU: ['Pacific/Honolulu', 'Honolulu'],
  PACIFIC_JOHNSTON: ['Pacific/Johnston', 'Johnston'],
  PACIFIC_KIRITIMATI: ['Pacific/Kiritimati', 'Kiritimati'],
  PACIFIC_KOSRAE: ['Pacific/Kosrae', 'Kosrae'],
  PACIFIC_KWAJALEIN: ['Pacific/Kwajalein', 'Kwajalein'],
  PACIFIC_MAJURO: ['Pacific/Majuro', 'Majuro'],
  PACIFIC_MARQUESAS: ['Pacific/Marquesas', 'Marquesas'],
  PACIFIC_MIDWAY: ['Pacific/Midway', 'Midway'],
  PACIFIC_NAURU: ['Pacific/Nauru', 'Nauru'],
  PACIFIC_NIUE: ['Pacific/Niue', 'Niue'],
  PACIFIC_NORFOLK: ['Pacific/Norfolk', 'Norfolk'],
  PACIFIC_NOUMEA: ['Pacific/Noumea', 'Noumea'],
  PACIFIC_PAGOPAGO: ['Pacific/Pago_Pago', 'Pago Pago'],
  PACIFIC_PALAU: ['Pacific/Palau', 'Palau'],
  PACIFIC_PITCAIRN: ['Pacific/Pitcairn', 'Pitcairn'],
  PACIFIC_PONAPE: ['Pacific/Pohnpei', 'Ponape'],
  PACIFIC_PORTMORESBY: ['Pacific/Port_Moresby', 'Port Moresby'],
  PACIFIC_RAROTONGA: ['Pacific/Rarotonga', 'Rarotonga'],
  PACIFIC_SAIPAN: ['Pacific/Saipan', 'Saipan'],
  PACIFIC_TAHITI: ['Pacific/Tahiti', 'Tahiti'],
  PACIFIC_TARAWA: ['Pacific/Tarawa', 'Tarawa'],
  PACIFIC_TONGATAPU: ['Pacific/Tongatapu', 'Tongatapu'],
  PACIFIC_TRUK: ['Pacific/Chuuk', 'Truk'],
  PACIFIC_WAKE: ['Pacific/Wake', 'Wake'],
  PACIFIC_WALLIS: ['Pacific/Wallis', 'Wallis']
}

const getTimeZoneId = (tz?: TimeZoneStrings): string =>
  // return current timezone if 'tz' is undefined
  tz ? TimeZoneInfo[tz][0] : Intl.DateTimeFormat().resolvedOptions().timeZone

export { TimeZone, AvailableTimeZones, TimeZoneInfo, getTimeZoneId }
